var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"id":"am_modal_content","show":_vm.showOverlay,"spinner-variant":"primary","spinner-type":"grow","spinner-small":"","rounded":"sm","variant":_vm.isDarkMode?'dark':'white',"opacity":"0.8"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }